import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { Badge } from 'baby-design'

import { CurrentState } from 'src/types/shipments'

import { shipmentBadgeColor } from '../ShipmentStatusSummaryBadge'

const badgeLabel = (currentState: NonNullable<CurrentState>) =>
  currentState.charAt(0).toUpperCase() + currentState.slice(1)

const ShipmentStatusBadge: FC<{ currentState: CurrentState }> = ({
  currentState,
}) => {
  if (!currentState || currentState === 'unknown') {
    return null
  }

  return (
    <Badge
      fill={shipmentBadgeColor(currentState)}
      label={badgeLabel(currentState)}
      size="medium"
      variant="general"
    />
  )
}

export default ShipmentStatusBadge
